<!-- =========================================================================================
  File Name: LabCard.vue
  Description: Item Component - Grid VIew

========================================================================================== -->

<template>
  <div>
    <vx-card class="grid-view-item mb-base overflow-hidden w-full no-padding" v-on="$listeners" @click="toggle = !toggle">
      <template slot="no-body">
        <vs-progress :percent="item.percent" class="block shadow-md bg-danger" color="success" v-if="item.percent !== 0"></vs-progress>
        <vs-progress :percent="100" class="block shadow-md bg-danger" color="danger" v-else></vs-progress>

        <div class="item-img-container flex items-center justify-center cursor-pointer">
          <img
            :src="item.thumbnail ? item.thumbnail : 'https://connect-cdn.intellectualpoint.com/assets/images/misc/default-placeholder.png'"
            :alt="item.name"
            class="grid-view-img"
            style="width: 100%; height: 300px; object-fit: cover"
          />
          <div class="assignment-card-overlay-top flex justify-between">
            <div>
              <img src="https://connect-cdn.intellectualpoint.com/assets/images/logos/IntellectualPointIcon.png" class="w-8" alt="" />
            </div>
            <div>
              <feather-icon
                v-if="item.percent === 100"
                icon="CheckCircleIcon"
                svgClasses="h-8 w-8 self-center bg-success rounded-full p-1 text-white"
              />
              <feather-icon v-else icon="XCircleIcon" svgClasses="h-8 w-8 self-center bg-danger rounded-full p-1 text-white" />
            </div>
          </div>
          <div class="assignment-card-overlay-bottom flex justify-between">
            <div>
              <h1 class="font-bold text-4xl" v-html="item.name"></h1>
              <p class="font-light">Due in {{ item.due }} days</p>
            </div>
            <div></div>
          </div>
        </div>
      </template>
    </vx-card>
    <vs-popup :active.sync="toggle" style-content="max-height: 600px" title="Assignment Details">
      <div class="p-3">
        <div class="flex items-center justify-between mb-4">
          <div class="flex items-center">
            <img src="https://sims-cdn.intellectualpoint.com/images/courses/CompTIASecurityPlus.png" width="75" class="rounded-lg mr-4" />
            <div>
              <h1 class="font-bold">{{ item.name }}</h1>
              <p class="font-light">Due in {{ item.due }} days</p>
            </div>
          </div>
          <radial-progress-bar
            :diameter="90"
            :completed-steps="item.percent"
            :total-steps="100"
            :animateSpeed="1100"
            timingFunc="ease"
            innerStrokeColor="#222f44"
            startColor="#31B952"
            stopColor="#0cdc62"
            :strokeWidth="7"
            :innerStrokeWidth="7"
          >
            <h3 class="font-light">{{ item.percent }}%</h3>
          </radial-progress-bar>
        </div>

        <p class="font-semibold">Description</p>
        <div class="p-3 rounded-lg mb-4" style="background: rgba(0, 0, 0, 0.35)">
          <h3 class="font-normal">
            Welcome to CompTIA Security+ Assignments<br />In this assignment your goal is to complete the following tasks
          </h3>
          <h3 class="font-light"><br />Tasks To Complete: <br />- Ports Practice Simulation<br />- FlashCards Sets A & B</h3>
          <h3 class="font-normal"><br />Need help?, send an email to prem@intellectualpoint.com</h3>
        </div>

        <p class="font-semibold">Tasks</p>
        <div style="background: rgba(0, 0, 0, 0.35)" class="flex justify-between items-center rounded-lg p-2 mb-2">
          <div class="flex items-center">
            <img
              alt=""
              src="https://media.discordapp.net/attachments/834871362812248185/846230314140827668/Integrity_Compromise.png"
              width="50"
              class="rounded-lg mr-3"
            />
            <div>
              <h3 class="font-semibold">Integrity Compromise</h3>
              <h6 class="font-light">Simulation Completion</h6>
            </div>
          </div>
          <feather-icon icon="CheckCircleIcon" svgClasses="w-10 h-10 text-success cursor-pointer" />
        </div>
        <div style="background: rgba(0, 0, 0, 0.35)" class="flex justify-between items-center rounded-lg p-2 mb-2">
          <div class="flex items-center">
            <img
              alt=""
              src="https://media.discordapp.net/attachments/834871362812248185/846230315335680040/Management_Control.png"
              width="50"
              class="rounded-lg mr-3"
            />
            <div>
              <h3 class="font-semibold">Management Control</h3>
              <h6 class="font-light">Simulation Completion</h6>
            </div>
          </div>
          <feather-icon icon="XCircleIcon" svgClasses="w-10 h-10 text-danger cursor-pointer" />
        </div>
        <div style="background: rgba(0, 0, 0, 0.35)" class="flex justify-between items-center rounded-lg p-2 mb-2">
          <div class="flex items-center">
            <img
              alt=""
              src="https://connect-cdn.intellectualpoint.com/assets/images/sets/security%2B/flashcard-set-a.png"
              width="50"
              class="rounded-lg mr-3"
            />
            <div>
              <h3 class="font-semibold">Security+ Set A</h3>
              <h6 class="font-light">FlashCard Set Completion</h6>
            </div>
          </div>
          <feather-icon icon="XCircleIcon" svgClasses="w-10 h-10 text-danger cursor-pointer" />
        </div>
        <div style="background: rgba(0, 0, 0, 0.35)" class="flex justify-between items-center rounded-lg p-2 mb-4">
          <div class="flex items-center">
            <img
              alt=""
              src="https://connect-cdn.intellectualpoint.com/assets/images/sets/security%2B/flashcard-set-b.png"
              width="50"
              class="rounded-lg mr-3"
            />
            <div>
              <h3 class="font-semibold">Security+ Set B</h3>
              <h6 class="font-light">FlashCard Set Completion</h6>
            </div>
          </div>
          <feather-icon icon="XCircleIcon" svgClasses="w-10 h-10 text-danger cursor-pointer" />
        </div>

        <p class="font-semibold">Progress</p>
        <div class="p-3 rounded-lg mb-4" style="background: rgba(0, 0, 0, 0.35)">
          <span class="font-bold" v-if="item.percent !== 100">You are currently at {{ item.percent }}% complete.</span>
          <span class="font-bold" v-else>You have completed the assignment!</span>
          <br />
          <span class="font-light">In order to complete this assignmet you must complete all tasks.</span>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import RadialProgressBar from 'vue-radial-progress';

export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  components: {
    RadialProgressBar,
  },
  data() {
    return {
      toggle: false,
    };
  },
  methods: {},
  created() {},
  computed: {
    activeCourseInfo() {
      return this.$store.state.AppActiveCourse;
    },
  },
};
</script>

<style lang="scss" scoped>
.grid-view-item {
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none;

  .grid-view-img {
    max-width: 100%;
    max-height: 100%;
    width: auto;
    transition: 0.35s;
  }

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, 0.25);

    .grid-view-img {
      opacity: 0.9;
    }
  }

  .vs-progress--background {
    z-index: 0 !important;
  }

  .assignment-card-overlay-top {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    padding: 1.25rem;
  }

  .assignment-card-overlay-bottom {
    position: absolute;
    bottom: 0;
    right: 0;
    left: 0;
    padding: 1.25rem 1.25rem 0.75rem 1.25rem;
  }
}
</style>
